import { ActionFactoryWithPlatformContext } from '../types';
import { initElementsPanelService } from '../../elementsPanelService';

export const elementsPanelActionFactory: ActionFactoryWithPlatformContext = ({
  hostAPI,
  editorPointer,
  documentServicesAPI,
  componentsAPI,
  editorPointerAPI,
  editorPlatformPackagesBridge,
}) => ({
  // TODO: add translation key
  actionName: 'elements',
  displayName: 'Elements Panel',
  tags: [],
  execute: async () => {
    const elementsPanelService = initElementsPanelService(
      documentServicesAPI,
      hostAPI,
      componentsAPI,
      editorPointerAPI,
    );

    const panelProps = elementsPanelService.getElementsPanelAPI(
      editorPointer,
      null,
    );

    const openElementsPanel =
      editorPlatformPackagesBridge?.PlatformElementsPanelAPI?.openElementsPanel;

    if (!openElementsPanel || !panelProps) {
      return;
    }

    openElementsPanel(panelProps);

    // const executionMethod = ActionExecutionStore.getExecutionMethod(
    //   ExecutionMethodsList.codePanel,
    // );

    // if (!executionMethod) {
    //   throw createEditorPlatformEditActionsError(
    //     EditorPlatformEditActionsErrorCode.EditActionExecutionMethodNotFound,
    //   ).withActionName('elements');
    // }

    // executionMethod(
    //   {
    //     panelContent: React.createElement(ElementsPanel, panelProps),
    //   },
    //   'Elements Panel',
    // );
  },
});
